// extracted by mini-css-extract-plugin
export var currencyInput = "_jd-1";
export var currencySymbol = "_jd-0";